"use client";
import { Button } from "../ui/button";
import { Download, ZoomIn, ZoomOut, RotateCcw } from "lucide-react";

interface ResumeControlBarProps {
  scale: number;
  setScale: (scale: number) => void;
  documentSize: string;
  document: React.ReactNode;
  fileName: string;
}

export const ResumeControlBar = ({
  scale,
  setScale,
  documentSize,
  document,
  fileName,
}: ResumeControlBarProps) => {
  const handleZoomIn = () => {
    setScale(Math.min(scale + 0.1, 2));
  };

  const handleZoomOut = () => {
    setScale(Math.max(scale - 0.1, 0.3));
  };

  const handleResetZoom = () => {
    setScale(0.8);
  };

  const handleDownload = () => {
    // This would trigger the download functionality
    // For now, we'll just log the action
    console.log("Download triggered for:", fileName);
  };

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-white border-2 border-black rounded-lg shadow-xl px-6 py-3 flex items-center justify-center space-x-4 z-50">
      <Button
        variant="outline"
        size="sm"
        onClick={handleZoomOut}
        disabled={scale <= 0.3}
        className="border-black text-black hover:bg-black hover:text-white transition-colors"
      >
        <ZoomOut className="h-4 w-4" />
      </Button>
      
      <span className="text-sm font-bold min-w-[60px] text-center text-black">
        {Math.round(scale * 100)}%
      </span>
      
      <Button
        variant="outline"
        size="sm"
        onClick={handleZoomIn}
        disabled={scale >= 2}
        className="border-black text-black hover:bg-black hover:text-white transition-colors"
      >
        <ZoomIn className="h-4 w-4" />
      </Button>
      
      <div className="w-px h-6 bg-black mx-2" />
      
      <Button
        variant="outline"
        size="sm"
        onClick={handleResetZoom}
        className="border-black text-black hover:bg-black hover:text-white transition-colors"
      >
        <RotateCcw className="h-4 w-4" />
      </Button>
      
      <div className="w-px h-6 bg-black mx-2" />
      
      <Button
        variant="outline"
        size="sm"
        onClick={handleDownload}
        className="border-black text-black hover:bg-black hover:text-white transition-colors"
      >
        <Download className="h-4 w-4" />
      </Button>
    </div>
  );
};
